import { render, staticRenderFns } from "./DkCheckbox.vue?vue&type=template&id=4cc3d855&"
import script from "./DkCheckbox.vue?vue&type=script&lang=js&"
export * from "./DkCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports